/**
 * Copyright (c) 2022 Cedalo GmbH
 */

import { runQuery, useSubscription } from '@cedalo/webui/src/ui/app/GraphQLWSClient';

import * as Query from './queries';
import * as Mutation from './mutations';
import * as Subscription from './subscriptions';
import { Path } from '@cedalo/webui/src/helper/Path';

export const useAccountsSubscription = () => useSubscription(Subscription.changes);
// export const useAccountUpdateSubscription = ({ accountId }) => useState([null, null]);
export const useAccountUpdateSubscription = (accountId) => useSubscription(Subscription.updates, { accountId });

export const getAccounts = async () => {
	try {
		const result = await runQuery(Query.integrations);
		return result.integrations;
	} catch (error) {
		console.log(error);
	}
	return [];
};
// or throw?
export const getAccount = async (integrationId) => {
	let result;
	try {
		const { integration } = await runQuery(Query.integration, { integrationId });
		result = integration ? { account: integration } : { errors: ['Unknown Integration'] };
	} catch (e) {
		result = { errors: [e.reason ? e.reason : e] };
	}
	return result;
};
export const getAccountModules = async () => {
	let result;
	try {
		const { integrationModules } = await runQuery(Query.integrationModules);
		result = integrationModules;
	} catch (error) {
		result = { success: false, message: error.message };
	}
	return result;
};

export const createAccount = async (type) => {
	let result;
	try {
		const created = await runQuery(Mutation.create, { type });
		result = created.createIntegration;
	} catch (error) {
		result = { success: false, message: error.message };
	}
	return result;
};
export const deleteAccount = async (id) => {
	let result;
	try {
		const deleted = await runQuery(Mutation.remove, { id });
		result = deleted.deleteIntegration;
	} catch (e) {
		result = { success: false, message: e.message };
	}
	return result;
};
export const setAccountName = async (id, name) => {
	let result;
	try {
		const updated = await runQuery(Mutation.update, { id, name });
		result = updated.updateIntegrationName;
	} catch (e) {
		result = { success: false, message: e.message };
	}
	return result;
};

export const runFormAction = async (formType, accountId, actionType, actionData /* = { id, value } */) => {
	const result = await runQuery(Mutation.action, { input: { form: formType, accountId, actionType, actionData } });
	return result;
};

export const getIntlKey = (key) => {
	switch (key) {
		case 'TabTitle.Accounts':
			return 'TabTitle.Integrations';
		case 'Tooltip.Create':
			return 'Tooltip.CreateIntegration';
		case 'Tooltip.CreateMessage':
			return 'Tooltip.CreateIntegrationMessage';
		case 'Table.Title':
			return 'Integration Accounts';
		case 'Table.SubTitle':
			return 'Create accounts for integration functions to share between multiple apps';
		case 'Table.Header.Type':
			return 'Extensions.Integrations.Table.Header.Type';
		default:
			return key;
	}
};

export const pathForId = (id) => Path.integration(id);
